import React from 'react'
import { Box, Paper, Typography, useTheme } from '@mui/material'
import { Grid } from '@mui/material'

const AAPPR2026 = () => {
  const theme = useTheme()

  return (
    <Box>
      <Grid container spacing={0} sx={{ width: '100%', m: 0, p: 0 }}>
        <Grid item xs={12} sx={{ width: '100%', m: 0, p: 0 }}>
          <Paper
            elevation={0}
            sx={{
              width: '100%',
              mb: 4,
              backgroundColor: theme.palette.background.dark,
              borderRadius: '0px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
              mx: 0,
            }}
          >
            <Box sx={{ maxWidth: '91.666667%', mx: 'auto', p: { xs: 2, md: 3 } }}>
              <Typography
                variant='h5'
                sx={{
                  color: 'white',
                  fontWeight: 'bold',
                  mb: 1,
                }}
              >
                Advancing Connections 2026
              </Typography>
              <Typography
                variant='caption'
                sx={{
                  color: 'rgba(255,255,255,0.7)',
                  display: 'block',
                }}
              >
                AAPPR Annual Conference
              </Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>

      <Grid container item xs={12} justifyContent='center'>
        <Grid item xs={11}>
          <Box
            sx={{
              py: 6,
              textAlign: 'center',
              color: theme.palette.text.secondary,
            }}
          >
            <Typography variant='body1'>Content coming soon.</Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default AAPPR2026
